import { io } from 'socket.io-client';
// Strip /api/v1 — the Socket.IO gateway lives at the server root, not under the REST prefix
const socketUrl = (import.meta.env.VITE_API_URL ?? '').replace(/\/api\/v\d+\/?$/, '');
// Created but NOT connected — useSocket hook manages the lifecycle.
// Connects when user authenticates, disconnects on logout.
export const socket = io(socketUrl, {
    autoConnect: false,
    withCredentials: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    timeout: 10000,
});
//# sourceMappingURL=socket.js.map